import React, { Component } from "react";
import AddLipShapeFileRender from "./children/AddLipShapeFileRender";
import AddLipShapeGIFRender from "./children/AddLipShapeGIFRender";
import "@/assets/addLipShape.less";

class AddLipShapeWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageAccept: ".gif, .jpg, .jpeg, .png, .bmp, .tiff, .web, .ico",
    };
  }

  render() {
    return (
      <div className="workplace-container">
        <AddLipShapeFileRender
          uploadHasEmailCallback={this.props.uploadHasEmailCallback}
          imageAccept={this.state.imageAccept}
          currFile={this.props.currFile}
          handleCloseCurrFile={this.props.handleCloseCurrFile}
        />
        <AddLipShapeGIFRender currFile={this.props.currFile} handleChooseTemplate={this.props.handleChooseTemplate} />
      </div>
    );
  }
}

export default AddLipShapeWorkFunction;
